import WondaLogo from "@/assets/images/vectors/wonda-logo.svg?react";
import { cn } from "@/common/utils";

type DigitLogoProps = {
  className?: string;
  variant?: "hero" | "nav";
  light?: boolean;
};

export function DigitLogo({
  className,
  variant = "hero",
  light = false,
}: DigitLogoProps) {
  const isNav = variant === "nav";
  return (
    <WondaLogo
      className={cn(
        "h-[clamp(36px,4.5vw,56px)] w-auto select-none",
        light ? "text-(--cli-text)/72" : "text-white/72",
        isNav && "h-6",
        className,
      )}
      aria-label="Wonda logo"
      role="img"
    />
  );
}
